import React from "react";
import { Outlet } from "react-router-dom";
import styled from "@emotion/styled";

const Root = styled.div`
  max-width: 520px;
  width: 100%;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
`;

interface AuthType {
  children?: React.ReactNode;
}

const Auth: React.FC<AuthType> = ({ children }) => {
  return (
    <Root>
      {children}
      <Outlet />
    </Root>
  );
};

export default Auth;
